/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eqeqeq */
import { Component } from "react";
import { IRepairTrackerProps, IRepairTrackerState } from "./RepairTrackerProps";
import moment from "moment";
import { IoCloseOutline } from "react-icons/all";
import { Overlay } from "../Overlay/Overlay";
import PhotosModal from "../shared/gallery-modal/GalleryModal";
import { Link } from "react-router-dom";
import { StepsProps, subTask } from "./TrackerStepper/TrackerStepperProps";

import { Box, Heading, Button, SimpleGrid } from "@chakra-ui/react";
import { InspectionService } from "../Services/inspectionService";
import { TrackerStepper } from "./TrackerStepper/TrackerStepper";
import { ImagesListEntity } from "../modals/JobEstimationDetail";

require("./RepairTracker.css");

export class RepairTracker extends Component<
  IRepairTrackerProps,
  IRepairTrackerState
> {
  inspectionsService = new InspectionService();
  inspection: any;

  params: any;
  inspectionLink = "/inspection";

  days: number = 0;

  constructor(props: IRepairTrackerProps) {
    super(props);
    let expectedArrival = this.getDate("arrival"),
      selectedPickupDate = this.getDate("pickup");
    this.state = {
      expectedArrival: expectedArrival
        ? expectedArrival.format("DD MMM YYYY ddd / hh:mm a")
        : "",
      expectedPickup: selectedPickupDate
        ? selectedPickupDate.format("DD MMM YYYY ddd / hh:mm a")
        : "",
      showRepairPhotos: false,
      inspectionForm: null,
      stepItems: [],
    };

    if (expectedArrival && selectedPickupDate) {
      const days = selectedPickupDate
        .startOf("day")
        .diff(expectedArrival.startOf("day"), "days");
      this.days = days;
    }
    const urlSearchParams = new URLSearchParams(
      window.location.search.toLowerCase()
    );
    this.params = Object.fromEntries(urlSearchParams.entries());
    if (this.params["estimateid"]) {
      this.inspectionLink =
        this.inspectionLink + "?estimateid=" + this.params["estimateid"];
    }

    this.checkInspection();
  }

  componentDidMount() {
    this.loadStepsState();
  }

  loadStepsState() {
    let newSteps: StepsProps[];

    this.createSteps().then((res: StepsProps[]) => {
      newSteps = res;
      this.setState({ stepItems: newSteps });
    });
  }

  async createSteps(): Promise<StepsProps[]> {
    const steps: StepsProps[] = [];
    Object.keys(this.props.stepItems).forEach((each: any) => {
      const status = this.props.stepItems[each]?.stepStatus;
      let label = each;
      let content;
      if (
        this.props.stepItems[each]?.stepStatus === "Completed" ||
        this.props.stepItems[each]?.stepStatus === "Complete"
      ) {
        label = this.props.stepItems[each]?.labelAfter;
        content = this.props.stepItems[each]?.detailAfter;
      } else {
        label = this.props.stepItems[each]?.labelBefore;
        content = this.props.stepItems[each]?.detail;
      }

      const step: StepsProps = {
        label: label,
        content: content,
        date:
          each === "collect"
            ? this.getDate("pickup", true)
            : each === "arrival"
            ? this.getDate("arrival", true)
            : this.getDate(each)?.format("DD MM YYYY"),
        stepStatus: status,
        onHoldReason: this.props.stepItems[each]?.onHoldReason,
        onHoldUntil: this.props.stepItems[each]?.onHoldUntil,
        isAccordion: this.props.stepItems[each]?.isAccordion,
        icon: this.props.stepItems[each]?.icon,
      };

      if (this.props.stepItems[each].subTasks) {
        const subTasks: any = this.props.stepItems[each].subTasks;
        const subTaskItem: subTask[] = [];
        if (subTasks) {
          Object.keys(subTasks).forEach((task: any) => {
            const subTaskStep: subTask = {
              label: subTasks[task]?.status,
              detail: subTasks[task]?.detail,
              subStepStatus: subTasks[task]?.stepStatus,
            };
            return subTaskItem.push(subTaskStep);
          });
          step.subTasks = subTaskItem;
        }
      }
      steps.push(step);
    });
    return steps;
  }

  getDate(type: string): moment.Moment;
  getDate(type: string, formatted: boolean): string;
  getDate(type: string, formatted?: boolean) {
    var dt = null;
    switch (type) {
      case "arrival":
        if (this.props.estimateDetails.isVehicleOnSite) {
          dt = this.props.estimateDetails?.actualArrival
            ? formatted
              ? "Arrived: " +
                moment(this.props.estimateDetails?.actualArrival)?.format(
                  "DD/MM/YYYY"
                )
              : moment(this.props.estimateDetails?.actualArrival)
            : null;
        } else {
          dt = this.props.estimateDetails?.expectedArrival
            ? formatted
              ? "Est. Arrival: " +
                moment(this.props.estimateDetails?.expectedArrival)?.format(
                  "DD/MM/YYYY"
                )
              : moment(this.props.estimateDetails?.expectedArrival)
            : null;
        }
        break;
      case "pickup":
        if (this.props.estimateDetails.isVehicleCollected) {
          dt = this.props.estimateDetails?.actualPickup
            ? formatted
              ? "Collected: " +
                moment(this.props.estimateDetails?.actualPickup)?.format(
                  "DD/MM/YYYY"
                )
              : moment(this.props.estimateDetails?.actualPickup)
            : null;
        } else {
          dt = this.props.estimateDetails?.expectedPickup
            ? formatted
              ? "Est. Collection: " +
                moment(this.props.estimateDetails?.expectedPickup)?.format(
                  "DD/MM/YYYY"
                )
              : moment(this.props.estimateDetails?.expectedPickup)
            : null;
        }
        break;
    }
    return dt;
  }

  async checkInspection() {
    if (this.props.estimateDetails.trackables) {
      this.props.estimateDetails.trackables
        .filter((x: any) => ["1PC"])
        .forEach(async (ele: any) => {
          if (ele.id == "1PC" && ele.status == "Completed") {
            let preChecks: any;
            preChecks = await this.inspectionsService.getInspectionById(
              this.props?.estimateDetails?.estimateId
            );
            if (preChecks.length > 0) {
              return this.setState({ inspectionForm: preChecks });
            }
          }
        });
    }
  }

  public render() {
    let images: any[] = [];
    this.props?.estimateDetails?.ImagesList?.forEach(
      (list: ImagesListEntity) => {
        return list?.images?.forEach((image: any) => {
          let filteredTrackable = false;
          if (
            this.props.estimateDetails.trackables &&
            this.props.estimateDetails.trackables.length > 0
          ) {
            this.props.estimateDetails.trackables
              .filter((x: any) => ["9RP"])
              .forEach((ele: any) => {
                if (ele.id == "9RP" && ele.status == "Completed") {
                  filteredTrackable = true;
                }
              });
          }
          if (image.category === "Handover" && filteredTrackable) {
            const url = this.props.ibsService.getHighResolutionImageUrl(
              image.full.id
            );
            let originalClass = "handover";
            const thumb = this.props.ibsService.getHighResolutionImageUrl(
              image.thumbnail.id
            );
            return images.push({
              original: url,
              thumbnail: thumb,
              originalClass: originalClass,
            });
          }
        });
      }
    );

    return (
      <Box>
        {this.state.showRepairPhotos ? (
          <Overlay isMenuOverlay={true}>
            <div className={"vehiclePhotoContainer"}>
              <div className={"closeIcon closeImagesDialog"}>
                <IoCloseOutline
                  onClick={() => this.setState({ showRepairPhotos: false })}
                />
              </div>
              <div className={"clearfix"}></div>
              {this.props.images.map((e) => {
                return (
                  <img
                    className={"vehiclePhoto"}
                    src={this.props.ibsService.getHighResolutionImageUrl(
                      e.full.id
                    )}
                  />
                );
              })}
            </div>
          </Overlay>
        ) : undefined}
        <Box>
          <Heading as="h2" mb={4} color="blue.700" size="md">
            Track the status of your repairs here. <br />
            {this.days !== 0 && ` Total of ${this.days} days in repair`}
          </Heading>
          <SimpleGrid mt={6} columns={1} spacing={3}>
            {this.state.inspectionForm !== null && (
              <Link to={this.inspectionLink}>
                <Button w={"100%"} colorScheme="blue">
                  Pre-repair Inspection Report
                </Button>
              </Link>
            )}
            {this.props.estimateDetails && images.length > 0 && (
              <PhotosModal props={this.props} imagesList={images}></PhotosModal>
            )}
          </SimpleGrid>

          <Box display="flex" flexFlow="column">
            {this.state.stepItems.length > 0 ? (
              <TrackerStepper {...this.state.stepItems}></TrackerStepper>
            ) : null}
          </Box>
        </Box>
      </Box>
    );
  }
}
